export default __webpack_public_path__ + "static/media/owner.81f01e71.svg";